import { fromJS } from 'immutable';
import * as constants from './sign-up-constants';
import { has, keys, equals, ifElse, or, call, cond, not, isEmpty, and, head, always, propEq, T, path } from 'ramda';

const initialState = fromJS({
  accomNumOfPages: 3,
  nonAccomNumOfPages: 3,
  buyerNumOfPages: 2,
  dmoNumOfPages: 2,
  otherNumOfPages: 2,
  step: 1,
  companyTypeChecked: [],
  selectedCompanyType: '',
  acctCreationReason: '',
  country: '',
  companyName: '',
  email: '',
  password: '',
  numOfIndicatorDots: '',
  oneOrMultiProperties: undefined,
  numOfProperties: undefined,
  oneOrMultiCities: undefined,
  companyNameChecked: false,
  foundExistingCompanyInfo: [],
  showFoundExistingCompanyInfo: false,
  searchSpinner: 'hide',
  existingCompanyId: undefined,
  creatingUser: false,
  showSignUpError: false,
  signUpError: '',
  disableSignUpButton: false,
  showExistingCompanyDialog: false,
});

const checkCompanyType = (state, selectedCompType) => call(cond([
  [equals('Accommodation'), always(state.get('accomNumOfPages'))],
  [equals('Non-Accommodation'), always(state.get('nonAccomNumOfPages'))],
  [equals('buyer'), always(state.get('buyerNumOfPages'))],
  [equals('dmo'), always(state.get('dmoNumOfPages'))],
  [equals('other'), always(state.get('otherNumOfPages'))],
]), selectedCompType);

const checkIfCompTypeCheckIsEmpty = (state, payload, selectedCompType) => {
  return ifElse(
    () => or(equals(state.get('companyTypeChecked').size, 0), equals(selectedCompType, state.get('selectedCompanyType'))),
      companyTypeChecked => companyTypeChecked.push(payload[keys(payload)]),
    () => initialState.get('companyTypeChecked').push(payload[keys(payload)])
  );
};

const stateOrInitialState = (state, selectedCompType) => {
  return call(ifElse(
    equals('other'),
      () => initialState,
    () => state
  ), selectedCompType);
};

export function signup(state = initialState, { type, payload }) {
  switch (type) {
    case 'UPDATE_SIGN_UP_PROPS':
      const updateObj = has(payload, 'companyName') ?
        Object.assign({}, payload, {
          existingCompanyId: '',
        }) : payload;
      return state.merge(fromJS(updateObj));
    case 'CHECK_ONE_FOR_COMPANY_TYPE':
      const selectedCompType = head(keys(payload));
      return stateOrInitialState(state, selectedCompType)
              .set('selectedCompanyType', selectedCompType)
              .set('numOfIndicatorDots', checkCompanyType(state, selectedCompType))
              .update('companyTypeChecked', checkIfCompTypeCheckIsEmpty(state, payload, selectedCompType));
    case 'UNCHECK_ONE_FOR_COMPANY_TYPE':
      return state.update('companyTypeChecked', companyTypeChecked => companyTypeChecked.filterNot(equals(payload)))
                  .set('selectedCompanyType', equals(state.get('companyTypeChecked').size, 1) ? '' : state.get('selectedCompanyType'));
    case 'COMPANY_NAME_SEARCH_STARTING':
      return state.set('companyNameChecked', true)
                  .set('searchSpinner', 'loading');
    case 'COMPANY_NAME_SEARCH_FINISHED':
      if (state.get('foundExistingCompanyInfo').size) {
        const existingCompanyId = path(['0', 'companyId'], state.get('foundExistingCompanyInfo').toJS().filter(obj => equals(obj.companyName.toUpperCase(), state.get('companyName').toUpperCase())));
        return state.set('companyNameChecked', false)
                    .set('foundExistingCompanyInfo', fromJS(payload || []))
                    .set('showFoundExistingCompanyInfo', Boolean(and(not(isEmpty(payload)), state.get('companyName').length)))
                    .set('searchSpinner', 'hide')
                    .set('existingCompanyId', existingCompanyId)
                    .set('signUpError', 'COMPANY')
                    .set('showSignUpError', true);
      }
      return state.set('companyNameChecked', false)
                  .set('foundExistingCompanyInfo', fromJS(payload || []))
                  .set('showFoundExistingCompanyInfo', Boolean(and(not(isEmpty(payload)), state.get('companyName').length)))
                  .set('searchSpinner', 'hide');
    case 'SIGN_UP_USER_STARTING':
      return state.set('creatingUser', true);
    case 'SIGN_UP_USER_FINISHED':
      return state.set('creatingUser', false)
                  .set('step', 5);
    case 'SIGN_UP_ERROR':
      return state.set('signUpError', payload)
                  .set('showSignUpError', true);
    case 'SIGN_UP_FAILED':
      const signUpError = call(
        cond([
          [propEq('error', 'User email already taken'), always('EMAIL')],
          [propEq('error', 'Company name already taken'), always('COMPANY')],
          [T, always('GENERIC')],
        ]),
        payload
      );
      return state.merge({
        showSignUpError: true,
        showExistingCompanyDialog: Boolean(equals(payload.error, 'Company name already taken')),
        signUpError,
      });
    case 'CLEAR_SIGNUP_REDUCER':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/sign-up/sign-up-reducer.js